import React from "react";
import { usePageHeaderContext } from "./PageHeaderContext";

export default function TopHeader() {
  const headerContext = usePageHeaderContext();
  const pageHeader = headerContext?.pageHeader;

  return (
    <header className="top-header">
      {pageHeader ? (
        <>
          <div className="top-header-copy">
            <h1 className="top-header-title">{pageHeader.title}</h1>
            {pageHeader.subtitle && (
              <p className="top-header-subtitle">{pageHeader.subtitle}</p>
            )}
          </div>
          {pageHeader.actions && (
            <div className="top-header-actions">{pageHeader.actions}</div>
          )}
        </>
      ) : (
        <div className="top-header-title">FrontLine</div>
      )}
    </header>
  );
}
